import React from 'react';
import PropTypes from 'prop-types';
import classes from './Paragraph.module.scss';

const Paragraph = ({ children }) => (
  <p className={classes.paragraph}>{children}</p>
);

Paragraph.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Paragraph;
